import { createReducer } from '@reduxjs/toolkit';
import {
  getLiveSessionSettings,
  getRegisteredSessionDetails,
  toggleSessionRegistration,
} from 'redux/actions/live-events';
import { map, omit, isEmpty } from 'underscore';
import { initialRootState } from '.';

const liveSessionSourceMapping = {
  ZOOM_USER_LEVEL: 'zoomOauth',
  ZOOM_ACCOUNT_LEVEL: 'zoomAccountOauth',
  MS_TEAMS_USER_LEVEL: 'microsoftGraphOauth',
};

export default createReducer(initialRootState, builder => {
  builder
    .addCase(getLiveSessionSettings.fulfilled, (state, action) => {
      const course = state.models.courses[action.meta.arg.catalogId];
      course.liveSessionSettings = action.payload;
      const integrations = {
        ZoomLiveSession: {},
      };
      const lecturePageId = state.app.lecturePage.currentLectureId;
      if (lecturePageId) {
        state.app.liveSessions.onceLoaded[lecturePageId] = true;
      }
      map(omit(action.payload, 'source', 'zoomAccountOauthUserId'), (integration, key) => {
        if (!isEmpty(integration)) {
          if (key === liveSessionSourceMapping.ZOOM_ACCOUNT_LEVEL) {
            integrations.ZoomLiveSession = {
              ...integration,
              source: key,
              authenticated: integration.authenticatedStatus === 'authenticated',
              needsReAuthentication: integration?.authenticatedStatus === 'not_authenticated',
              zoomUserId: action.payload.zoomAccountOauthUserId,
            };
          }
          if (
            key === liveSessionSourceMapping.ZOOM_USER_LEVEL
          || key === liveSessionSourceMapping.MS_TEAMS_USER_LEVEL
          ) {
            integrations[key === liveSessionSourceMapping.ZOOM_USER_LEVEL ? 'ZoomLiveSession' : 'TeamsLiveSession'] = {
              ...integration,
              source: key,
              authenticated: integration?.authenticatedStatus === 'authenticated',
              needsReAuthentication: integration?.authenticatedStatus === 'not_authenticated',
            };
          }
        }
      });
      state.app.liveSessions.integrations = integrations;
      if (action.meta.arg.userId) {
        state.app.liveSessions.settings[action.meta.arg.userId] = action.payload;
      }
    })
    .addCase(toggleSessionRegistration.fulfilled, (state, action) => {
      state.app.liveSessions.sessions[action.meta.arg.sessionId] = action.payload;
    });
});
